"use client";

import { useEffect } from "react";

import { useSnackbar } from "notistack";

import { setSessionRequiredNoticeListener } from "@/common/helpers/sessionRequiredNotice";
import { useTranslate } from "@/common/hooks/useTranslate";

export const SessionRequiredNotice = () => {
  const { t } = useTranslate();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    setSessionRequiredNoticeListener(({ exhausted }) => {
      if (exhausted) {
        enqueueSnackbar(t("common", "sessionRequiredExhaustedNotice"), {
          vibe: "danger",
          preventDuplicate: true,
          persist: true,
          buttonsProps: [
            {
              key: "reload",
              children: t("common", "sessionRequiredReloadAction"),
              onClick: () => window.location.reload(),
            },
          ],
        });
        return;
      }
      enqueueSnackbar(t("common", "sessionRequiredBlockerNotice"), {
        vibe: "danger",
        preventDuplicate: true,
        autoHideDuration: 10_000,
      });
    });
    return () => setSessionRequiredNoticeListener(null);
  }, [enqueueSnackbar, t]);

  return null;
};
